// Run the request immediately, keeping retry feedback visible even on fast failures.
export const withMinimumLoadingDuration = async (request, duration = 2000) => {
    const [result] = await Promise.allSettled([
        request,
        new Promise(resolve => setTimeout(resolve, duration)),
    ])
    if (result.status === "rejected") throw result.reason
    return result.value
}
